import { Alert, AlertProps, styled } from '@mui/material'
import { ComponentType } from 'react'

export const ToastAlert: ComponentType<AlertProps> = styled( Alert )<AlertProps>( ( { theme } ) => ( {
	'borderRadius': theme.shape.borderRadius,
	'maxWidth': '450px',
	'padding': theme.spacing( 1 ),
	'& .MuiAlert-message': {
		padding: '2px 8px 2px 8px',
	},
} ) )
